import { useSharedChatGroupValidations } from '@gem/modules/validations';
import type { IChatGroupValidations } from '@gem/modules/validations';

import { groupAliasAsyncValidation } from '../fields/fields';

export const useChatGroupValidations = (): IChatGroupValidations => {
  return useSharedChatGroupValidations({
    groupAliasAsyncValidation,
  });
};
